import type { SidebarRenderProps } from '@/apps/latest/components/templates/Layout'

import { NutritionSidebar } from './NutritionSidebar'

// 管理栄養士の 2 ページ (home / session) が共有カーネルの器に渡すもの。

// Layout の左ペイン (renderSidebar) に渡す。
export const renderNutritionSidebar = (props: SidebarRenderProps) => (
  <NutritionSidebar {...props} />
)
